import { render, staticRenderFns } from "./ProjectResponse.vue?vue&type=template&id=1678c0c2&scoped=true"
import script from "./ProjectResponse.vue?vue&type=script&lang=js"
export * from "./ProjectResponse.vue?vue&type=script&lang=js"
import style0 from "./ProjectResponse.vue?vue&type=style&index=0&id=1678c0c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678c0c2",
  null
  
)

export default component.exports